/*
 * Behaviour for static blog content rendered by sections/main-article.liquid.
 * Article bodies contain markup only - this file is loaded once by the section, so it never
 * has to be pasted into each post.
 *
 * 1. Table-of-contents active state. theme.js calls preventDefault() on same-page "#" links to
 *    smooth-scroll, so the hash never changes and :target never fires. It dispatches a
 *    "hashchange:simulate" event instead; we listen for that (plus real hashchange for
 *    back/forward and direct links) and toggle .is-active by hand.
 * 2. Share links. Content marks them with data-share="whatsapp|facebook|copy" and this file
 *    fills in the real URL, so posts never hardcode their own address.
 */
(() => {
  const init = (wrapper) => {
    if (wrapper.dataset.staticInit) return;
    wrapper.dataset.staticInit = 'true';

    const links = wrapper.querySelectorAll('.article-html-nav-link[href^="#"]');
    const setActive = (hash) => {
      links.forEach((link) => {
        link.classList.toggle('is-active', link.getAttribute('href') === hash);
      });
    };
    document.documentElement.addEventListener('hashchange:simulate', (event) => setActive(event.detail?.hash));
    window.addEventListener('hashchange', () => setActive(location.hash));
    if (location.hash) setActive(location.hash);

    const url = location.origin + location.pathname;
    const title = document.title;
    wrapper.querySelectorAll('[data-share]').forEach((link) => {
      switch (link.dataset.share) {
        case 'whatsapp':
          link.href = `https://wa.me/?text=${encodeURIComponent(`${title} ${url}`)}`;
          link.target = '_blank';
          link.rel = 'noopener';
          break;
        case 'facebook':
          link.href = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
          link.target = '_blank';
          link.rel = 'noopener';
          break;
        case 'copy':
          link.addEventListener('click', (event) => {
            event.preventDefault();
            navigator.clipboard?.writeText(url);
          });
          break;
      }
    });
  };

  const run = () => document.querySelectorAll('.article-html--static').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-run when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', run);
})();
